module.exports = __webpack_public_path__ + "img/alert-square-rounded-filled.dad45e6e.svg";